import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { IconCheck, IconX, IconHelp, IconCopy } from '@tabler/icons-react';
import ReactDOM from 'react-dom';
import { Modal, Group, Text, ActionIcon } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { SelectTooltip, useColorScheme } from "../GeneralComponent/GeneralComponent";

export function TestMode({ selectedMemberWebsite, pageId, taguchiTestId, testModeShow, isTestMode, setMarksalestime, TestOptimizeReport, systemUsageLoader, setTestModeName}:any) {
	const navigate = useNavigate();
	const [showTestModeModal, setShowTestModeModal] = useState(false);
	const [testModeUrl, setTestModeUrl] = useState("");
	const testModeIconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const colorTheme = useColorScheme();

  useEffect(() => {
    if (isTestMode) {
	    systemUsageLoader(true);
	  	TestsApi.savetestmode({
	      system_website_id: selectedMemberWebsite,
	      page_id:pageId,
	      taguchi_type_id:taguchiTestId,
	      testmode:testModeShow
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {
	          navigate("/logout");
	        }
	      }
	    })
	    .then(data => {
	      if (data.status === 1) {
	        systemUsageLoader(false);
	        setMarksalestime(data.data.updated_time);
	        setTestModeName(data.data.test_mode_name);
	        setShowTestModeModal(data.data.show_popup);
	        setTestModeUrl(data.data.testmode_url);
	        TestOptimizeReport();
	        notifications.show({
	          color: 'green',
	          icon: <IconCheck size="1.1rem" />,
	          title: 'Success',
	          message: data.message,
	        });
	      } else {
	      	notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: data.message,
	        });
	        systemUsageLoader(false);
	      }
	    })
	    .catch(error => {
	      systemUsageLoader(false);
	      console.error("API Error:", error);
	    });
    }
  }, [isTestMode, pageId]);

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (testModeIconRef.current) {
      const { top, left, width } = testModeIconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  const handleTestModeCloseModal = () => {
  	setShowTestModeModal(false);
  };

  return (
    <>
    	{showHelpModal &&
        ReactDOM.createPortal(
          <div style={{ zIndex: 9999 }}>
            <SelectTooltip
              isVisible={showHelpModal}
              setIsVisible={setShowHelpModal}
              id={helpTargetId}
              tooltipPosition={tooltipPosition}
            />
          </div>,
        document.body
      )}
    	{showTestModeModal && (
    		<Modal.Root opened={showTestModeModal} onClose={handleTestModeCloseModal} size="55%" trapFocus={false}>
	        <Modal.Overlay />
	        <Modal.Content style={{ width: 700 }}>
	          <Modal.Header>
	            <Modal.Title>Test Mode <IconHelp ref={testModeIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(341)}/></Modal.Title>
	            <Modal.CloseButton />
	          </Modal.Header>
	          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
						  <Group spacing={5} align="center">
						    <Text weight={500}>Start testing with this URL:</Text>
						    <Group spacing={5} align="center">
							    <Link
							      to={testModeUrl}
							      target="_blank"
							      style={{
							        textDecoration: "none",
							        color: colorTheme === "light" ? "black" : "white",
							        wordBreak: "break-all",
							      }}
							    >
							      {testModeUrl}
							    </Link>
							    <ActionIcon
							      onClick={() => navigator.clipboard.writeText(testModeUrl)}
							      title="Copy URL"
							      variant="subtle"
							    >
							      <IconCopy size={16} />
							    </ActionIcon>
							  </Group>
						  </Group>
						</Modal.Body>
	        </Modal.Content>
	      </Modal.Root>
    	)}
    </>
  );
}